/**
 * State Model Normalization Layer
 * 
 * Goal: Ensure stable data shapes regardless of API changes.
 * All components receive normalized data — never raw API responses.
 */

/**
 * Normalize coin/market data from pageHome API
 */
export function normalizeCoin(raw) {
  const hr = raw.twentyFourHrResp || {}
  return {
    id:         raw.id,
    symbol:     raw.coinName || `${raw.fromSymbol}${raw.toSymbol}`,
    fromSymbol: raw.fromSymbol,
    toSymbol:   raw.toSymbol,
    iconUrl:    raw.iconUrl || '',
    price:      hr.lastPrice || '0',
    change:     hr.priceChangePercent || '0',
    changeVal:  hr.priceChange || '0',
    high:       hr.highPrice || '',
    low:        hr.lowPrice || '',
    volume:     hr.volume || '',
    bidPrice:   hr.bidPrice || '',
    askPrice:   hr.askPrice || '',
    isStar:     raw.isStar || false,
  }
}

/**
 * Normalize banner list from API
 */
export function normalizeBanner(raw) {
  if (!raw) return []
  // Accept array of {fileId} or {url}
  return (Array.isArray(raw) ? raw : [raw]).map(item => ({
    fileId: item.fileId || '',
    url: item.url || '',
  }))
}

/**
 * Normalize partner list from API
 */
export function normalizePartner(raw) {
  if (!raw) return []
  return (Array.isArray(raw) ? raw : [raw]).map(item => ({
    fileId: item.fileId || '',
    url: item.url || '',
  }))
}

/**
 * Normalize site config from hashMap/getIsDisplay API
 */
export function normalizeConfig(raw) {
  return {
    navLeft:    raw.navLeft ? safeParse(raw.navLeft, []) : [],
    tabBar:     raw.tabBarConfig ? safeParse(raw.tabBarConfig, {}) : {},
    marketShow: raw.market_show ? safeParse(raw.market_show, {}) : {},
    homeTheme:  raw.homeTheme1 || 'dappDefi',
    swiperUrl:  raw.swiperUrl || '1',
    showAi:     raw.ai || '0',
    showFinance: raw.showFinance || '0',
    // ... extend as needed
  }
}

/**
 * Full home page data normalizer
 * This is the single entry point for all components.
 */
export function normalizeHomeData(raw) {
  const content = raw.content || []
  return {
    coins:    content.map(normalizeCoin),
    banners:  raw.banners ? normalizeBanner(raw.banners) : [],
    partners: raw.partners ? normalizePartner(raw.partners) : [],
    config:   raw.config ? normalizeConfig(raw.config) : {},
  }
}

// ---- Utils ----

function safeParse(val, fallback) {
  if (!val) return fallback
  if (typeof val === 'object') return val
  try { return JSON.parse(val) } catch { return fallback }
}
